<template>
  <div :id="company.id" class="list-box-container" @mouseup="$_can('companies.show')">
    <template>
      <div class="d-flex list-box-header col-12 pointer" @click.middle.exact="viewMiddle($event, company.id)" @click.left.exact="view($event, company.id)">
        <div class="pl-0 list-box-header-left col-lg-7 col-7 col-md-6 pr-3">
          <div class="pl-0 d-flex align-items-center col-5 col-md-6">
            <div class="list-box-status align-items-start col-12">
              <span class="ref-id">
                {{ company.name }}
              </span>
            </div>
          </div>
          <div class="pl-0 d-flex align-items-center col-7">
            <div class="list-box-status align-items-start col-12">
              <span v-if="company.status.name === 'Active'"
                    :class="'btn-status btn-active'"
              >{{ company.status.name }}</span>
              <span v-if="company.status.name === 'Inactive'"
                    :class="'btn-status btn-pending'"
              >{{ company.status.name }}</span>
              <span v-if="company.status.name === 'Setup Incomplete'"
                    :class="'btn-status btn-rejected'"
              >{{ company.status.name }}</span>
            </div>
          </div>
        </div>
        <div class="list-box-header-right col-lg-5 col-5 pl-4">
          <div class="d-flex align-items-center col-12">
            {{ company.rating ? company.rating : 'No reviews' }}
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    company: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({}),
  methods: {
    viewMiddle(event, id) {
      const routeData = this.$router.resolve({
        path: `/reports/ratings/${id}`,
        query: { data: this.q },
      });
      window.open(routeData.href, '_blank');
    },
    view(event, id) {
      this.$router.push(
        `/reports/ratings/${id}${this.q ? `?q=${encodeURIComponent(this.q)}` : ''}`,
      );
    },
  },
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: none;
}
.list-box-status {
  align-items: normal;
}
.list-box-header {
  min-height: 66px;
}
.full-name {
  font-weight: 500;
  font-size: 16px;
  color: #4c5669;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/ratings/RatingsBlock.vue